import { paymentTransactionSettingConstants } from "../constants";

export function paymentTransactionSetting(state = {}, action) {
  switch (action.type) {
    case paymentTransactionSettingConstants.LOADING_REQUEST:
      return {
        ...state,
        loding: action.isbool,
      };

    case paymentTransactionSettingConstants.DIALOG_REQUEST:
      return {
        ...state,
        showDialog: action.isbool,
      };

    case paymentTransactionSettingConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case paymentTransactionSettingConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.datas,
      };
    case paymentTransactionSettingConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case paymentTransactionSettingConstants.CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      };
    case paymentTransactionSettingConstants.CREATE_SUCCESS:
      if (!action.data) {
        return state;
      }
      return {
        ...state,
        items:
          state.items == null ? [action.data] : [action.data, ...state.items],
      };
    case paymentTransactionSettingConstants.CREATE_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case paymentTransactionSettingConstants.UPDATE_REQUEST:
      return {
        ...state,
        items: state.items.map((item) =>
          item.SettingId === action.data.SettingId
            ? { ...item, updating: true }
            : item
        ),
      };
    case paymentTransactionSettingConstants.UPDATE_SUCCESS:
      if (!action.data) {
        return state;
      }
      return {
        ...state,
        items: state.items.map((item) =>
          item && item.SettingId === action.data.SettingId ? action.data : item
        ),
      };
    case paymentTransactionSettingConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case paymentTransactionSettingConstants.DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      };
    case paymentTransactionSettingConstants.DELETE_SUCCESS:
      return {
        ...state,
        items: state.items.filter(
          (item) => item.SettingId !== action.data
        ),
      };
    case paymentTransactionSettingConstants.DELETE_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    default:
      return state;
  }
}
